import type { FC } from 'react';

import { Grid } from '@interstate/components/Grid';
import { RadioButtonList } from '@interstate/components/RadioButtonList';
import { Typography } from '@interstate/components/Typography';
import type { PriorLeaseBalanceApplyMethod } from '@makemydeal/dr-offer-redux';

import type { PriorBalanceApplyMethodOption } from './constants';
import { PRIOR_BALANCE_APPLY_METHOD_GROUP_NAME, PRIOR_BALANCE_APPLY_METHOD_HEADING } from './constants';
import { ApplyMethodDescription, ApplyMethodOptionWrapper, ApplyMethodSection } from './priorBalance.styles';

export type PriorBalanceApplyMethodProps = {
    value: PriorLeaseBalanceApplyMethod;
    options: PriorBalanceApplyMethodOption[];
    onChange: (value: PriorLeaseBalanceApplyMethod) => void;
};

export const PriorBalanceApplyMethod: FC<PriorBalanceApplyMethodProps> = ({ value, options, onChange }) => (
    <ApplyMethodSection>
        <Typography variant="strong-md" tag="h6" data-testid="prior-balance-apply-method-heading" sx={{ margin: 0 }}>
            {PRIOR_BALANCE_APPLY_METHOD_HEADING}
        </Typography>
        <Grid container columnSpacing={1} rowSpacing={2}>
            {options.map((option) => (
                <Grid key={option.value} xs={12} xl={4}>
                    <ApplyMethodOptionWrapper>
                        <RadioButtonList
                            name={PRIOR_BALANCE_APPLY_METHOD_GROUP_NAME}
                            displayLabel={false}
                            data-testid={`prior-balance-apply-method-${option.value}`}
                            options={[{ value: option.value, label: option.label }]}
                            value={value === option.value ? option.value : ''}
                            onChange={() => onChange(option.value)}
                            sx={{
                                gap: 0,
                                '&& .ids-input-layout-vertical': { rowGap: 0 },
                                '&& .MuiGrid2-root': { paddingTop: 0, paddingBottom: 0 },
                                '&& .MuiFormGroup-root': { paddingTop: 0 },
                                '&& .MuiFormControlLabel-root': { marginBottom: 0, alignItems: 'center' },
                                '&& .MuiFormControlLabel-label': { padding: 0, lineHeight: 1.2 }
                            }}
                        />
                        <ApplyMethodDescription>
                            <Typography variant="body-sm" color="sem.color.on-surface.muted" tag="span" sx={{ margin: 0 }}>
                                {option.description}
                            </Typography>
                        </ApplyMethodDescription>
                    </ApplyMethodOptionWrapper>
                </Grid>
            ))}
        </Grid>
    </ApplyMethodSection>
);
